import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

interface ReasonModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    reason: string;
}

export function ReasonModal({
    open,
    onOpenChange,
    title = "ເຫດຜົນການປະຕິເສດ",
    reason,
}: ReasonModalProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>
                        ລາຍລະອຽດເຫດຜົນການປະຕິເສດ
                    </DialogDescription>
                </DialogHeader>
                <div className="p-4 mt-2 rounded-md bg-muted">
                    <p className="text-sm text-foreground">{reason || "ບໍ່ມີເຫດຜົນລະບຸ"}</p>
                </div>
            </DialogContent>
        </Dialog>
    );
}
